$(document).ready(function () {
  function changeLocations(element) {
    var searchWrapper = element.closest('.js-locations-filter');
    var selectedRegionId = searchWrapper
      .find('.js-region-search')
      .find('option:selected')
      .val();
    var url = searchWrapper.data('url');
    var locale = searchWrapper.data('currency-short-cut');
    var orderBy = searchWrapper.find('.is-active').data('location-order');
    var searchText = searchWrapper
      .find('.js-search-locations-by-search-text')
      .val();

    $.ajax({
      type: 'POST',
      url: url,
      dataType: 'json',
      data: {
        regionId: selectedRegionId,
        locale: locale,
        orderBy: orderBy,
        q: searchText,
      },
      success: function (data) {
        $('.js-locations-content').html(data.renderView);
      },
    });
  }

  if (document.readyState == 'interactive') {
    let searchVillasOptions = $('.select-items');
    if (searchVillasOptions.closest('.js-locations-filter').length !== 0) {
      for (let i = 0; i < searchVillasOptions.length; i++) {
        searchVillasOptions[i].addEventListener('click', function () {
          changeLocations($(this));
        });
      }
    }
  }

  $('.js-location-order-by').bind('click', function () {
    $('.js-location-order-by').toggleClass('is-active');
    changeLocations($(this));
  });
  $('.js-search-locations-by-search-text').on('keypress', function (e) {
    clearTimeout(200);
    changeLocations($(this));
  });
  $('.js-search-locations-by-search-button').bind('click', function () {
    changeLocations($(this));
  });
});
